export const SERVICES_COLUMNS = {
	name: "name",
	service_name: "text_mkqem1mt",
	service_pictures: "file_mkqe9afa",
	status: "status",
	briefs: "board_relation_mks0jgdp",
} as const;
